import {
  IconButton,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { t } from "i18next";
import { handleCheckListStatus } from "../../../../utils/functions/checkListPractice";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

const CoreTableDocCategory = ({ getDocList, onNavigate, status }) => {
  return (
    <div className="w-7/12 text-center flex flex-col">
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow style={{ backgroundColor: "#e6e6e6" }}>
              <TableCell>{t("Category")}</TableCell>
              <TableCell>{t("Documents")}</TableCell>
              <TableCell>{t("Status")}</TableCell>
              <TableCell>{t("Actions")}</TableCell>
            </TableRow>
          </TableHead>
          {getDocList?.map((documento) => (
            <TableRow className="hover:shadow-md" key={documento.categoryId}>
              <TableCell>{documento.categoryName}</TableCell>
              <TableCell>{documento.docCount}</TableCell>
              <TableCell>{handleCheckListStatus(documento)}</TableCell>
              <TableCell>
                <Tooltip title={t("Visualize")}>
                  <IconButton
                    onClick={() => onNavigate(documento.categoryId)}
                    className="w-10 h-10"
                    disabled={
                      status === "Annullata" || status === "ChiusaPositivo"
                    }
                  >
                    <SearchRoundedIcon />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
          {getDocList?.length === 0 && (
            <TableRow>
              <TableCell colSpan={4} className="text-center text-gray">
                {t("NoDocs")}
              </TableCell>
            </TableRow>
          )}
        </Table>
      </TableContainer>
    </div>
  );
};

export default CoreTableDocCategory;
